/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
  MessageHeader, Message,
} from "semantic-ui-react";

import Abstract from "./Abstract.js";
// import Results from "./Results.js";
// import Comparison from "./Comparison.js";
// import Results from "./Results.js";

// import MyCarousel from "./Carousel.js";
// import Video from './Video.js';
import YouTube from './YouTube.js';
// import overview from "./images/framework-crop-1.jpg";
// import teaser from './images/teaser.png';
// import video_website from "./video/video-website.mp4";

import subsection_style from "./style.js";
// import MyCarousel from "./Carousel.js";
// import fig_noisy from './images/fig_noisy.jpg'
import './App.css'
import task from './images/task.jpg'
import llm from './images/llm.jpg'
import method from './images/method.jpg'

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

/* Heads up!
 * HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled
 * components for such things.
 */
const HomepageHeading = ({ mobile }) => (
  <Container fluid>
    {/* <Header
      as="h1"
      content="SinNeRF"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "2em" : "4em",
        fontWeight: "normal",
        marginBottom: 0,
        marginTop: mobile ? "0.5em" : "1em",
      }}
    /> */}
    <Header
      as="h1"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "1.5em" : "1.7em",
        fontWeight: "normal",
        marginTop: mobile ? "0.5em" : "1em",
      }}
    >
      <div>
      Comp4D: Compositional 4D Scene Generation
      </div>
    </Header>
  </Container>
);

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
};

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Media greaterThan="mobile">
        <HomepageHeading />
        {children}
      </Media>
    );
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
};

class MobileContainer extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Media as={Sidebar.Pushable} at="mobile">
        <HomepageHeading mobile />

        {children}
      </Media>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
};

const ResponsiveContainer = ({ children }) => (
  /* Heads up!
   * For large applications it may not be best option to put all page into these containers at
   * they will be rendered twice for SSR.
   */
  <MediaContextProvider>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </MediaContextProvider>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

const Authors = () => (      <Container text>
  {/* <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
  </Grid> */}
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}
    <a href="https://ir1d.github.io/" target="_blank" rel="noreferrer">
      Dejia Xu<sup>1*</sup>
    </a>
    <a href="#" target="_blank" rel="noreferrer">
      Hanwen Liang<sup>2*</sup>
    </a>
    <a href="https://neel1302.github.io/" target="_blank" rel="noreferrer">
      Neel P. Bhatt<sup>1</sup>
    </a>
    <a href="https://alexhu.top/" target="_blank" rel="noreferrer">
      Hezhen Hu<sup>1</sup>
    </a>
    <a href="#" target="_blank" rel="noreferrer">
      Hanxue Liang<sup>3</sup>
    </a>
    <a href="https://www.comm.utoronto.ca/~kostas/" target="_blank" rel="noreferrer">
      Konstantinos N. Plataniotis<sup>2</sup>
    </a>
    <a
      href="https://express.adobe.com/page/CAdrFMJ9QeI2y/"
      target="_blank"
      rel="noreferrer"
    >
      Zhangyang Wang<sup>1</sup>
    </a>
    {/* </Grid.Column> */}
    {/* </Grid.Row> */}
  </Grid>
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
    <div>
      <sup>1</sup>University of Texas at Austin, <sup>2</sup>University of Toronto, <sup>3</sup>University of Cambridge<br />
      <sup>*</sup>Equal contribution
    </div>
  {/* </Grid>
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  > */}
    {/* <br /> */}
    {/* <div>*denotes equal contribution</div> */}
  </Grid>
  <Grid
        container
        stackable
        verticalAlign="middle"
        columns={2}
        width={10}
        textAlign="center"
        style={{
          fontSize: "1.2em",
          fontWeight: "normal",
          marginTop: "0.5em",
          marginBottom: "0.5em",
        }}
      >
        <Grid.Row>
          <Grid.Column columns={2}>
            <Button primary icon >
              <a
                href="https://arxiv.org/abs/2403.16993"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="book" />
                {" Paper"}
              </a>
            </Button>
            <Button primary icon >
              <a
                href="https://github.com/VITA-Group/Comp4D"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="github" />
                {" Code"}
              </a>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
</Container>
)

const HomepageLayout = ({ mobile }) => (
  <ResponsiveContainer>
    <div>
      <Authors />

      <Container text style={{textAlign: "justify",}}>
      {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Overview
        </Header> */}
        {/* <MyCarousel mobile={mobile} ></MyCarousel> */}
        <p>
        <b>TL;DR:</b> We introduce Comp4D, <b>compositional 4D scene synthesis</b> from text input. Compared with previous object-centric 4D generation pipelines, our <u>Comp</u>ositional <u>4D</u> Generation (<b>Comp4D</b>) framework integrates GPT-4 to decompose the scene and design proper trajectories, resulting in larger-scale movements and more realistic object interactions.
        </p>
        {/* <br></br> */}
        {/* <Comparison /> */}
        {/* <Results /> */}
        <Abstract mobile={mobile} />
        {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Visualizations
        </Header> */}
        {/* <MyCarousel mobile={mobile} /> */}
        <Header as="h2" textAlign="center" style={subsection_style}>
          Video (narrated)
        </Header>
        <br></br>
        <YouTube src={`https://www.youtube.com/embed/ToCzqy7_myI?rel=0&amp;autoplay=p1&mute=1`}></YouTube>
        {/* <Video /> */}
        <Header as="h2" textAlign="center" style={subsection_style}>
        Compositional 4D Scene Generation
        </Header>
        <p>
        Previous work concentrate on object-centric 4D objects. In comparison, our work extends the boundaries to the demanding task of constructing <b>compositional 4D scenes</b>. We integrate GPT-4 to decompose the scene and design proper trajectories, resulting in larger-scale movements and more realistic object interactions.
        </p>
        <Image src={task} style={subsection_style} centered="true" ></Image>
        <br></br>
        <Header as="h2" textAlign="center" style={subsection_style}>
        Method
        </Header>
        <p>
        Here's an overview of our proposed <b>Comp4D</b> method. Given an input text, first, we use LLM for scene decomposition to obtain multiple individual 3D objects. Subsequently, we adopt LLM to design the object trajectories which guide the displacements of objects in the optimization of compositional 4D scene. Thanks to the compositional 4D representation implemented with 3D Gaussians, in each iteration of the compositional score distillation process, we are able to switch between object-centric rendering and trajectory-guided rendering flexibly.
        </p>
        <Image src={method} style={subsection_style} centered="true" ></Image>
        <p>
        Here's the overall pipeline for object trajectory generation. First, a scene description is provided by a human user as a prompt to an LLM which yields relative object scale information required for rendering. Subsequently, the language model is prompted with this information along with environmental constraints and tasked to return a function that takes timestep as an input and returns the corresponding object's 3D position governed by kinematic equations. After the collection of a set of positions, collision checking is performed to clip the trajectory where the first collision occurs. Optionally, premature collisions can be mitigated by re-querying the LLM for an improved function.
        </p>
        <Image src={llm} style={subsection_style} centered="true" ></Image>
        <Header as="h2" textAlign="center" style={subsection_style}>
        Results
        </Header>
        <p>
        Our method is evaluated against 4D content creation baselines. Our Comp4D framework generates compositional 4D scenes with more realistic motion and object interactions.
        <br></br>
        </p>
        {/* <Image src={fig_noisy} style={subsection_style}></Image> */}
        <YouTube src={`https://www.youtube.com/embed/j5NeoKUKVO0?rel=0&amp;autoplay=p1&mute=1`}></YouTube>
        <Header as="h2" textAlign="center" style={subsection_style}>
          Citation
        </Header>
        <p style={{ paddingBottom: "0.5em", overflow: "auto" }}>
          If you want to cite our work, please kindly use:
          <pre>
            <code>
              {`@article{xu2024comp4d,
  title={Comp4D: LLM-Guided Compositional 4D Scene Generation},
  author={Xu, Dejia and Liang, Hanwen and Bhatt, Neel P and Hu, Hezhen and Liang, Hanxue and Plataniotis, Konstantinos N and Wang, Zhangyang},
  journal={arXiv preprint arXiv:2403.16993},
  year={2024}
}\}`}
            </code>
          </pre>
        </p>
        <Header as="h2" textAlign="center" style={subsection_style}>
        Relevant Works
        </Header>
        <Message info color='teal'>
    <MessageHeader><a href="https://vita-group.github.io/4DGen/" target="_blank" rel="noreferrer">
    4DGen: Grounded 4D Content Generation with Spatial-temporal Consistency
    </a></MessageHeader>
    We introduce grounded 4D content generation. We identify static 3D assets and monocular video sequences as key components in constructing the 4D content. 
  </Message>
        <Message info color='teal'>
    <MessageHeader> <a href="https://vita-group.github.io/3D-Mode-Collapse/" target="_blank" rel="noreferrer">
    Taming Mode Collapse in Score Distillation for Text-to-3D Generation
    </a></MessageHeader>
    We derive an entropy-maximizing score distillation rule that fosters view diversity and address the multi-face problem for text-to-3D generation.
  </Message>
  <Message info color='teal'>
    <MessageHeader> <a href="https://vita-group.github.io/SteinDreamer/" target="_blank" rel="noreferrer">
    SteinDreamer: Variance Reduction for Text-to-3D Score Distillation via Stein Identity
    </a></MessageHeader>
    We adopt control variate method constructed by Stein identity to reduce variance in Monte Carlo estimation for text-to-3D score distillation.
  </Message>
        <br></br>
      </Container>
    </div>
  </ResponsiveContainer>
);

export default HomepageLayout;
